module.exports = __webpack_public_path__ + "img/hr-red-desert-bush-03.a2ad1a8f.png";